import { Box, Typography } from '@mui/material'
import hourglassImage from 'assets/images/ani_hourglass.gif'

// Hourglass indicator shown while the DAC flow decides whether to reveal the widget.
const DacProcessingIndicator = () => (
  <Box display="flex" alignItems="center" gap={1}>
    <img src={hourglassImage} alt="Ladevorgang" width={20} height={20} />
    <Typography variant="caption" color="#848484" fontSize="12px">
      Wir prüfen, ob der digitale Kontoauszug erforderlich ist
    </Typography>
  </Box>
)

export default DacProcessingIndicator
